import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Table from '../../common/components/Table';
import { PAGE_SIZE } from '../../common/constants/page-size';
import { BaseResponse } from '../../common/interfaces/base-response';
import RowOptionsButton from '../../common/components/RowOptionsButton';
import { ItemType } from '../../common/enums/item-type';
import { GroupType } from '../../common/entities/GroupType';
import GroupTypeFormModal from '../../common/components/FormModals/GroupTypeFormModal';
import CustomSeparator from '../../common/components/BreadCrumbs';
import MamamHeader from '../../common/components/MamamH3';

export default function GroupTypes() {
	const [page, setPage] = useState(0);
	const [searchOptions, setSearchOptions] = useState('');
	const [sendReq, setSendReq] = useState(false);
	const [open, setOpen] = useState(false);
	const [groupTypes, setGroupTypes] = useState<BaseResponse<GroupType>>();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		axios
			.request({
				method: 'GET',
				url: `/group_type?page=${page}&limit=${PAGE_SIZE}${searchOptions}`,
			})
			.then((response) => {
				setGroupTypes(response.data);
			})
			.catch((error) => console.error(error))
			.finally(() => setLoading(false));
	}, [page, searchOptions, sendReq]);

	const applyFilters = (filters: string) => {
		setSearchOptions(filters);
		setSendReq(!sendReq);
	};

	const handlePageChange = (pageNumber: number) => {
		setPage(pageNumber);
		setSendReq(!sendReq);
	};

	const handleClickAdd = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleSave = () => {
		setSendReq(!sendReq);
	};

	const rows: GridRowsProp =
		groupTypes?.data?.map((row) => ({ ...row, options: row.id })) || [];

	const columns: GridColDef[] = [
		{
			field: 'options',
			headerName: '',
			width: 100,
			cellClassName: 'table-options',
			headerClassName: 'table-options-header',
			renderCell(params) {
				return (
					<RowOptionsButton
						itemId={params.value}
						handleSave={handleSave}
						tabIndex={params.tabIndex}
						itemType={ItemType.GROUP_TYPE}
					/>
				);
			},
		},
		{ field: 'name', headerName: '', width: 370 },
	];

	return (
		<div>
			{open && (
				<GroupTypeFormModal
					open={open}
					handleClose={handleClose}
					handleSaveParent={handleSave}
					title="Agregar tipo de grupo"
					parentType={ItemType.GROUP_TYPE}
				/>
			)}
			<CustomSeparator
				crumbs={[{ name: 'Tipos de grupo', path: '/tipos-grupo' }]}
			/>
			<MamamHeader text="Tipos grupo" marginBlock="1.5rem" />
			<Table
				rows={rows}
				columns={columns}
				loading={loading || !groupTypes?.data}
				onPageChange={handlePageChange}
				rowCount={groupTypes?.count}
				applyFilters={applyFilters}
				handleClickAdd={handleClickAdd}
				itemType={ItemType.GROUP_TYPE}
			></Table>
		</div>
	);
}
